import { fetcher } from '../../lib/request';
import { Dispatch } from 'redux';

import { SearchParams } from '../../models/Flight/SearchParams';

export const AIRPORTS_FARES_REQUEST = 'FLIGHT_AIRPORTS_FARES_REQUEST';
export const AIRPORTS_FARES_RESPONSE = 'FLIGHT_AIRPORTS_FARES_RESPONSE';
export const AIRPORTS_FARES_ERROR = 'FLIGHT_AIRPORTS_FARES_ERROR';

export const CREATE_SEARCH_FARES_REQUEST = 'FLIGHT_CREATE_SEARCH_FARES_REQUEST';
export const CREATE_SEARCH_FARES_RESPONSE = 'FLIGHT_CREATE_SEARCH_FARES_RESPONSE';
export const CREATE_SEARCH_FARES_ERROR = 'FLIGHT_CREATE_SEARCH_FARES_ERROR';

export const CLEAR_SEARCH_OBJECT = 'FLIGHT_CLEAR_SEARCH_OBJECT';
export const CLEAR_SEARCH_RESULTS = 'FLIGHT_CLEAR_SEARCH_RESULTS';

export const GET_AVIASALES_PAYMENT_LINK_REQUEST = 'FLIGHT_GET_AVIASALES_PAYMENT_LINK_REQUEST';
export const GET_AVIASALES_PAYMENT_LINK_RESPONSE = 'FLIGHT_GET_AVIASALES_PAYMENT_LINK_RESPONSE';
export const GET_AVIASALES_PAYMENT_LINK_ERROR = 'FLIGHT_GET_AVIASALES_PAYMENT_LINK_ERROR';

const AVIASALES_HOST = process.env.REACT_APP_AVIASALES_HOST;
const AVIASALES_KEY = process.env.REACT_APP_AVIASALES_KEY;

export const getSearchFaresResultsAction = (id: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: AIRPORTS_FARES_REQUEST,
        id
    });

    try {
        const response = await fetcher(`${AVIASALES_HOST}/api/client/v1/searches/${id}`)
            .auth(`Basic ${AVIASALES_KEY}`)
            .get()
            .fetch().then(res => res.status === 200 && res.json());

        dispatch({
            type: AIRPORTS_FARES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: AIRPORTS_FARES_ERROR,
            error
        });
    }
};

export const createSearchFaresAction = (params: SearchParams) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CREATE_SEARCH_FARES_REQUEST,
        params
    });

    try {
        const response = await fetcher(`${AVIASALES_HOST}/api/client/v1/searches`)
            .post(params)
            .contentType('application/json')
            .auth(`Basic ${AVIASALES_KEY}`)
            .json();

        dispatch({
            type: CREATE_SEARCH_FARES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: CREATE_SEARCH_FARES_ERROR,
            error
        });
    }
};

export const clearSearchObjectAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLEAR_SEARCH_OBJECT
    });
};

export const clearSearchResultsAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLEAR_SEARCH_RESULTS
    });
};

export const getPaymentLinkAction = (id: number, code: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_AVIASALES_PAYMENT_LINK_REQUEST,
        id,
        code
    });

    try {
        const response = await fetcher(`${AVIASALES_HOST}/api/client/v1/searches/${id}/link?code=${code}`)
            .auth(`Basic ${AVIASALES_KEY}`)
            .json();

        dispatch({
            type: GET_AVIASALES_PAYMENT_LINK_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_AVIASALES_PAYMENT_LINK_ERROR,
            error
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Flight/fares.ts